import { render, staticRenderFns } from "./AddALawyer.vue?vue&type=template&id=59237669&scoped=true&"
import script from "./AddALawyer.vue?vue&type=script&lang=ts&"
export * from "./AddALawyer.vue?vue&type=script&lang=ts&"
import style0 from "./AddALawyer.vue?vue&type=style&index=0&id=59237669&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59237669",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
